import { SchemaFormApi, SchemaFormOptions } from "../shared/types";
import { ReactNode } from "react";
import { z } from "zod/v4";
import useSchemaForm from "../hooks/use-schema-form";
import { FormProvider } from "../contexts/form-context";
import { FieldSet } from "../modules/field-set";

export interface SchemaFormHookProps<in out TSchema extends z.ZodType> extends SchemaFormOptions<TSchema> {
    children?: ReactNode | ((form: SchemaFormApi<TSchema>) => ReactNode)
}

export default function SchemaFormHook<TSchema extends z.ZodType>({
    children,
    schema,
    ...props
}: SchemaFormHookProps<TSchema>): ReactNode {
    const form = useSchemaForm({ schema, ...props });
    return <FormProvider form={form}>
        <FieldSet fieldSet={form.fieldSet}>
            {typeof children === "function" ? children(form) : children}
        </FieldSet>
    </FormProvider>
}